import { render, staticRenderFns } from "./dangerTypeMap.vue?vue&type=template&id=5a72c3c4&scoped=true&"
import script from "./dangerTypeMap.vue?vue&type=script&lang=js&"
export * from "./dangerTypeMap.vue?vue&type=script&lang=js&"
import style0 from "./dangerTypeMap.vue?vue&type=style&index=0&id=5a72c3c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72c3c4",
  null
  
)

export default component.exports